import { ref, set, onValue, push, child, remove, update} from "firebase/database";
import { database } from "@/firebase/firebaseInit";

import store from "@/store";

class Database {
    constructor() {
        this.currentUserId = null
        this.database = null
        this.userRef = null;
        this.userRef = null
        this.userRef = null
        this.boardsRef = null;
    }

    async init(userId) {
        this.currentUserId = userId;
        this.database = ref(database);
        this.userRef = child(this.database, `/user/${this.currentUserId}`);
        this.userRef = this.userRef || this.addUser(this.currentUserId);
        this.boardsRef = child(this.userRef, `/boards`);
        this.startReadingBoards();
    }

    // --------------------------------------------------------------------------------------------


    // START SERVICE METHODS

    async addUser (userId) {
        return await set(ref(database, `user/${userId}`), {
            boards: {},
        }).then(() => child(this.database, `user/${userId}`));
    }
    
    async addBoard(boardName) {
        const newBoardRef = await push(this.boardsRef);
        set(newBoardRef, {
            name: boardName,
            id: newBoardRef.key
        }).then(() => {

        }).catch(error => {
            console.log(error);
        })
    }

    async deleteBoard(boardId) {
        const targetBoard = child(this.boardsRef, `/${boardId}`);
        remove(targetBoard);
    }

    async addTask(boardId, taskData) {
        const subTasks = taskData.subtasks;
        delete taskData.subtasks;
        const targetBoardTasks = child(this.boardsRef, `/${boardId}/tasks`);
        const newTaskRef = await push(targetBoardTasks, '/tasks');
        taskData.boardId = boardId;
        taskData.taskId = newTaskRef.key;
        await set(newTaskRef, taskData);
        subTasks.forEach(async (subtask) => {
            const newSubtaskRef = await push(child(newTaskRef, '/subtasks'));
            const newSubtaskKey = newSubtaskRef.key;
            subtask.taskId = newTaskRef.key;
            subtask.boardId = boardId;
            subtask.id = newSubtaskKey;
            debugger;
            await set(newSubtaskRef, subtask)
        })
    }

    async updateTaskStatus(boardId, taskId, newStatus) {
        const targetTask = child(this.boardsRef, `${boardId}/tasks/${taskId}`);
        await update(targetTask, {
            status: newStatus
        })
    }

     async deleteTask(boardId, taskId) {
        const targetTask = child(this.boardsRef, `${boardId}/tasks/${taskId}`);
        await remove(targetTask);
    }   

    async updateSubTaskStatus(boardId, subtaskData) {
        console.log('boardId:', boardId, subtaskData)
        const targetSubtask = child(this.boardsRef, `/${boardId}/tasks/${subtaskData.taskId}/subtasks/${subtaskData.id}`);
        await set(targetSubtask, subtaskData);
    }



    startReadingBoards () {
        // Database Listener
        onValue(this.boardsRef, (snapshot) => {
            const payload = snapshot.val();
            const convertToArray = true
            store.commit('TasksModule/storeBoards', { payload, convertToArray });
            store.commit('TasksModule/setDisplayedBoard', store.state.TasksModule?.displayedBoard?.id)
        })
    }

    // END SERVICE METHODS

    // --------------------------------------------------------------------------------------------

    // START UTILS


    // END UTILS
}

export default new Database;




